export default {
  home: {
    sections: {
      trendingToday: "Heute im Trend",
      offers: "Angebote",
      partners: "Partner",
      cheatsheets: "Cheatsheets",
      predictionMarkets: "Prognosemärkte",
      advancedTools: "Erweiterte Tools",
      parlays: "Kombiwetten",
      upcomingGames: "Anstehende Spiele",
    },
    offers: {
      types: {
        FANTASY_FREE_PICK: "Tägliche Tipps",
        BOOST: "Boosts",
        SPORTSBOOK_SIGNUP: "Sportwettenanbieter",
        FANTASY_SIGNUP: "Fantasy",
        PREDICTION_SIGNUP: "Vorhersage",
        SWEEPSTAKES_SIGNUP: "Sweepstakes",
        CASINO_SIGNUP: "Casino",
        PARTNER: "Partner",
      },
    },
    offseason: {
      eyebrow: "Offseason",
      body: "Bis bald zur neuen Saison!",
    },
    seasonChampion: {
      description: "{{team}} sind die {{championship}}.",
      descriptionWithArticle: "Die {{team}} sind die {{championship}}.",
      descriptions: {
        default: "{{league}}-Meister",
        superbowl: "Super-Bowl-Champions",
        stanleyCup: "Stanley-Cup-Champions",
        premierLeague: "Premier-League-Meister",
        worldSeries: "World-Series-Champions",
        european: "Europameister",
        europaLeague: "Europa-League-Sieger",
        ncaaBasketball: "NCAA-Basketball-Champions",
        ncaaFootball: "NCAA-Football-Champions",
      },
    },
    noGamesToday: "Heute gibt es keine Spiele in der {{league}}.",
    currentlyInOffseason: "Derzeit in der Offseason.",
    featured: {
      gameOfDay: "Spiel des Tages",
      gameOfWeek: "Spiel der Woche",
      parlayTrends: "Kombiwetten-Trends",
      cheatsheets: "Cheatsheets",
      unlockRewardTitle: "Belohnung freischalten",
      unlockRewardSubtitle: "Premium-Zugang einlösen, um mehr zu sehen.",
      unlockRewardBody: "Erhalte Zugriff auf mehr Trends, Tools und Analysen.",
    },
    cards: {
      placeItOn: "Wette bei",
      advancedToolsCta: "Linemate+ beitreten",
      premiumBlurb: "Schalte das volle Erlebnis frei. Analysiere jeden Trend tiefer.",
    },
    empty: {
      trend: "Keine Trends verfügbar. Bitte später erneut vorbeischauen.",
      cheatsheet: "Keine Cheatsheets verfügbar. Bitte später erneut vorbeischauen.",
      offer: "Keine Angebote verfügbar. Bitte später erneut vorbeischauen.",
    },
    cheatsheets: {
      recentForm: "Aktuelle Form",
      versusOpponent: "Gegen Gegner",
      alternateLines: "Alternative Linien",
      firstQuarter: "1. Viertel",
      firstHalf: "1. Halbzeit",
      homeAwayGames: "Heim-/Auswärtsspiele",
      teamForm: "Teamform",
      undersOnly: "Nur Under",
    },
    tools: {
      props: "Props",
      markets: "Märkte",
      cheatsheets: "Cheatsheets",
      generateParlay: "Kombiwetten-Generator",
      lineups: "Aufstellungen",
      injuries: "Verletzungen",
      rank: "Rang",
      weather: "Wetter",
      pitchers: "Pitcher",
      stats: "Statistiken",
      standings: "Tabellen",
    },
    generateParlay: {
      parlayType: {
        subtitle: "Nutze die aktuelle Form, direkte Duelle oder die Heim- und Auswärtsleistung.",
        recentFormDescription: "Leistung in den letzten 20 Spielen",
        versusOpponentDescription: "Letzte 20 Spiele gegen diesen Gegner",
        homeAwaySplitsDescription: "Letzte 20 Heim- oder Auswärtsspiele",
      },
      legs: {
        title: "Wie viele Tipps möchtest du?",
        subtitle: "Wähle die Größe der Kombiwette, die du erstellen möchtest",
        label: "{{count}} Tipps",
      },
      participants: {
        title: "Wer soll dabei sein?",
        subtitle: "Wähle die Teams oder Spieler aus, die du in deiner Kombiwette haben möchtest",
        searchPlayer: "Spieler suchen",
        searchTeam: "Team suchen",
        allPlayers: "Alle Spieler",
        allTeams: "Alle Teams",
      },
      result: {name: "Kombiwette", title: "Deine Kombiwette"},
      empty: {
        title: "Keine Kombiwette gefunden",
        subtitle: "Ändere deine Auswahl, um eine Kombiwette zu erstellen.",
      },
      actions: {goHome: "Zurück zur Startseite", share: "Kombiwette teilen"},
      loader: {
        ready: "Kombiwette bereit",
        accessibilityLabel: "Deine Kombiwette wird erstellt",
        values: {
          legs: "{{count}} Tipps...",
          allGames: "Alle Spiele...",
          selectedGames: "{{count}} Spiele...",
          allPlayers: "Alle Spieler...",
          allTeams: "Alle Teams...",
          selectedParticipants: "{{count}} Teilnehmer...",
          selectedBetTypes: "{{count}} Wettarten...",
          selectedSportsbooks: "{{count}} Sportsbooks...",
          building: "Deine Kombiwette wird erstellt...",
        },
      },
    },
    predictionMarkets: {
      hubTitle: "Prognosemarkt-Hub",
      values: {
        points: "{{count}} Pkt.",
        trades: "{{count}} Trades",
      },
      analysis: {
        title: "Marktanalyse",
        allExchanges: "Alle Börsen",
        perExchange: "Pro Börse",
        chips: {
          all: "Alle",
          oneDay: "1 Tag",
          oneWeek: "1 Woche",
        },
        rows: {
          volume: "Volumen",
          movement: "Bewegung",
          marketSplit: "Marktabweichung",
          largestTrade: "Größter Trade",
          activity: "Aktivität",
        },
      },
      cards: {
        mostVolume: {
          title: "Höchstes Volumen",
          description: "Märkte mit dem meisten gehandelten Geld",
        },
        largestTrades: {
          title: "Größte Trades",
          description: "Märkte mit den größten Einzeltrades",
        },
        biggestMovers: {
          title: "Größte Bewegungen",
          description: "Märkte mit den größten Wahrscheinlichkeitsänderungen",
        },
        marketsSplit: {
          title: "Marktabweichung",
          description: "Märkte mit den größten Unterschieden zwischen Plattformen",
        },
        mostActivity: {
          title: "Meiste Aktivität",
          description: "Märkte mit der höchsten Anzahl an Trades",
        },
      },
      previews: {
        superBowlWinner: "Super-Bowl-Sieger",
        nbaChampions: "NBA-Champions",
        worldSeriesWinner: "World-Series-Sieger",
        easternConference: "Eastern Conference",
        westernConference: "Western Conference",
        nfcWinner: "NFC-Sieger",
        afcChampions: "AFC-Champions",
        alPennant: "AL-Pennant",
        stanleyCup: "Stanley Cup",
        afcEast: "AFC East",
        afcNorth: "AFC North",
        nfcNorth: "NFC North",
        nfcWest: "NFC West",
        nlCentral: "NL Central",
        nlWest: "NL West",
        premierLeague: "Premier League",
        divisionWinner: "Divisionssieger",
      },
    },
    advancedTools: {
      marketAgainst: "{{market}} gegen",
      vsOpponent: "vs. {{opponent}}",
    },
    sponsoredBy: "Gesponsert von {{operator}}",
  },
};
